import React, { useState, useEffect } from "react";
import { StyleContextProvider } from "./contexts/StyleContext";
import ErrorBoundary from "./components/ErrorBoundary";
import Header from "./components/header/Header";

import Blogs from "./containers/blogs/Blogs";
import BasicGallery from "./containers/gallery/BasicGallery";
import Contact from "./containers/contact/Contact";
import Footer from "./components/footer/Footer";
import BackToTop from "./components/backToTop/BackToTop";
import AboutMeRuchi from "./containers/aboutMe/AboutMeRuchi";
import Projects from "./containers/projects/Projects";
import CombinedTimeline from "./containers/combinedTimeline/CombinedTimeline";

// Import all required data from portfolio
import {
  greeting,
  skillsSection,
  workExperiences,
  projects,
  blogSection,
  gallerySection
} from "./portfolio";

// Import styles
import "./styles/_global.scss";
import "./App.scss";
import "./appleThemeOverride.scss"; // Import Apple theme override
import "./forceAppleTheme.css"; // Force Apple theme with !important rules

function App() {
  // Default to light mode
  const [isDark, setIsDark] = useState(false);
  const [repos, setRepos] = useState([]);

  // Add scroll-to-top functionality for the Home button
  useEffect(() => {
    const handleScrollToHome = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };

    // Listen for custom home navigation events
    window.addEventListener('scrollToHome', handleScrollToHome);

    // Log portfolio data for debugging
    console.log('Portfolio data loaded');
    console.log('Gallery section:', gallerySection);
    console.log('Gallery images:', gallerySection.images);

    return () => {
      window.removeEventListener('scrollToHome', handleScrollToHome);
    };
  }, []);

  // Fetch GitHub repositories
  useEffect(() => {
    const fetchRepos = async () => {
      try {
        console.log('Fetching GitHub repositories...');
        const response = await fetch("/profile.json");

        if (!response.ok) {
          throw new Error(`Failed to fetch profile data (Status: ${response.status})`);
        }

        const data = await response.json();
        console.log('GitHub data received:', data);

        if (!data || !data.data || !data.data.user || !data.data.user.pinnedItems) {
          throw new Error("Invalid profile data structure");
        }

        const repoEdges = data.data.user.pinnedItems.edges || [];
        console.log('Repositories found:', repoEdges.length);
        setRepos(repoEdges);
      } catch (error) {
        console.error("Error fetching GitHub repos:", error);
        setRepos([]);
      }
    };

    fetchRepos();
  }, []);

  return (
    <StyleContextProvider value={{ isDark, setIsDark }}>
      <ErrorBoundary>
        <div className="App">
          <Header />
          <main className="main-content">
            <div id="home">
              <AboutMeRuchi />
            </div>
            <div id="projects">
              <Projects repos={repos} />
            </div>
            <div id="experience-education">
              <CombinedTimeline />
            </div>

            <div id="blogs">
              <Blogs />
            </div>
            <div id="gallery">
              <BasicGallery />
            </div>
            <div id="contact">
              <Contact />
            </div>
          </main>
          <Footer />
          <BackToTop />
        </div>
      </ErrorBoundary>
    </StyleContextProvider>
  );
}

export default App;
